import { Injectable } from "@angular/core";
import { FormQuestion } from "../../admin/events-screen/event-page-models/form-question";
import { EventFormCustomFormType } from "../../admin/events-screen/event-page-models/event-form-custom-form-type";

@Injectable()
export class SpecialTypeEventsService {
  public static specialEventsFormQuestionsModifier(
    formQuestions: FormQuestion[],
    typeOfQuestion:
      | "parentAdvance"
      | "parentDetails"
      | "childEventAdvancedDetails",
    eventFormCustomFormType: EventFormCustomFormType
  ) {
    switch (eventFormCustomFormType) {
      case EventFormCustomFormType.Michlol:
        return SpecialTypeEventsService.modifyMichlolQuestions(
          formQuestions,
          typeOfQuestion
        );
      case EventFormCustomFormType.common:
        break;
      case EventFormCustomFormType.Product:
        break;
      case EventFormCustomFormType.Donation:
        break;
      case EventFormCustomFormType.NestProduct:
    }
    return formQuestions;
  }
  public static modifyMichlolQuestions(
    formQuestions: FormQuestion[],
    typeOfQuestion:
      | "parentAdvance"
      | "parentDetails"
      | "childEventAdvancedDetails"
  ) {
    let modifiedFormQuestion = formQuestions;
    switch (typeOfQuestion) {
      case "parentDetails":
        modifiedFormQuestion =
          SpecialTypeEventsService.staticHideFormQuestionFields(
            modifiedFormQuestion,
            [
              "eventType",
              "eventStartDate",
              "eventStartHour",
              "eventEndDate",
              "eventEndHour",
              "eventCollection",
            ]
          );
        modifiedFormQuestion =
          SpecialTypeEventsService.renameFormQuestionFields(
            modifiedFormQuestion,
            new Map(
              Object.entries({
                eventName: "שם המכלול",
                eventDescription: "תאור המכלול",
              })
            )
          );
        return modifiedFormQuestion;

      case "parentAdvance":
        formQuestions = SpecialTypeEventsService.staticHideFormQuestionFields(
          formQuestions,
          []
        );
        formQuestions = SpecialTypeEventsService.renameFormQuestionFields(
          formQuestions,
          new Map(
            Object.entries({
              eventCode: "קוד המכלול",
            })
          )
        );
        return formQuestions;
      case "childEventAdvancedDetails":
        formQuestions = SpecialTypeEventsService.staticHideFormQuestionFields(
          formQuestions,
          [
            "eventDescription",
            "eventStartDate",
            "eventStartHour",
            "eventEndDate",
            "eventEndHour",
            "registrationStartDate",
            "registrationEndDate",
            "closedToMembersChildEvent",
            "brothersDiscountChildEvent",
          ]
        );

        return formQuestions;
    }
    return formQuestions;
  }
  public static staticHideFormQuestionFields(
    formQuestions: FormQuestion[],
    fieldNames: string[]
  ) {
    formQuestions.forEach((q) => {
      if (!fieldNames.includes(q.fieldName)) {
        return;
      }
      q.customAttributes = q.customAttributes || {};
      q.customAttributes.alwaysHide = true;
    });
    return formQuestions;
  }
  public static renameFormQuestionFields(
    formQuestions: FormQuestion[],
    newFieldText: Map<string, string>
  ) {
    formQuestions.forEach((q) => {
      if (!newFieldText.has(q.fieldName)) {
        return;
      }
      q.label = newFieldText.get(q.fieldName);
    });
    return formQuestions;
  }
  public static deepCopyFormQuestions(
    formQuestions: FormQuestion[]
  ): FormQuestion[] {
    return formQuestions.map((q) => ({
      ...q,
      customAttributes: { ...q.customAttributes },
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/eventsServices/specialTypeEvents.service.ts